import {inject, Pipe, PipeTransform} from '@angular/core';
import {AppointmentDto} from '../../../shared/dtos/appointment.dto';
import {TranslocoService} from '@jsverse/transloco';

@Pipe({
  name: 'appointmentType'
})
export class AppointmentTypePipe implements PipeTransform {
  translocoService = inject(TranslocoService);

  transform(appointmentDto: AppointmentDto): unknown {
    if (appointmentDto.appointmentTypeId == 5) {
      return appointmentDto.title ?? this.translocoService.translate('appointmentType.group');
    }

    return appointmentDto.title ?? this.translocoService.translate('appointmentType.default');
  }

}
